import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getHashtagDetails } from '@opm/services';
import { useEffect, useState } from 'react';

export function useHashtagDetails({ filter }: { filter: any }) {
  const [data, setData] = useState<any>({});
  const [firstAvailableTime, setFirstAvailableTime] = useState<string>('');
  const { wrapperCancelRequest, loading } = useCancelRequestHook();

  function request() {
    if (!filter?.hashtag) return;
    wrapperCancelRequest(getHashtagDetails, filter)
      .then(data => {
        setData(data);
        // 直接在 hook 内部处理 firstAvailableTime
        if (data?.first_available_time) {
          setFirstAvailableTime(data.first_available_time);
        }
      })
      .catch(() => {});
  }

  useEffect(() => {
    if (filter) {
      request();
    }
  }, [filter]);

  return {
    data,
    loading,
    firstAvailableTime,
  };
}